<template>
  <div>
    <div
      style="
        border-bottom: 1px solid rgba(155, 155, 155, 0.25);
        margin-bottom: 20px;
      "
    >
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="申请企业" style="margin-right: 30px">
          <el-input v-model="formInline.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            :editable="false"
            :clearable="false"
            v-model="formInline.date_range"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
            class="bg5584FF formBotton"
            >查询</el-button
          >
          <el-button type="info" @click="reset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- <el-link style="margin-bottom: 20px;" type="primary" @click="exportData">{{exportLabel}}</el-link> -->
    <el-table
      border
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
      v-loading="loading"
    >
      <el-table-column
        prop="name"
        label="申请企业"
        align="center"
        show-overflow-tooltip
        fixed
      >
        <template slot-scope="scope">
          <span class="detail" @click="handleDetail1(scope.row)">{{
            scope.row.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="applyName"
        label="申请人"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="申请时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="applyPhone"
        label="联系电话"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="reason"
        label="申请原因"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="handleName"
        label="办理人"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="handleDepartment"
        label="办理部门"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="handleTime"
        label="办理时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="opinion"
        label="审核意见"
        align="center"
      ></el-table-column>
    </el-table>
    <!-- <div class="pageBox">
      <el-pagination
        class="pagePC"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="10"
        layout="total,  prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <van-pagination
        class="pagePhone"
        v-model="currentPage"
        :total-items="total"
        :items-per-page="10"
        :show-page-size="3"
        @change="changePage"
        force-ellipses
      />
    </div> -->
    <el-dialog
      v-if="showDialogVisible"
      title="报表详情"
      :visible.sync="showDialogVisible"
      class="dialog770 titleChange"
      width="1160px"
      append-to-body
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <zdquczbShow
        v-if="editCode == '001'"
        :id="zdjcqyczbId"
        :report_yidong="report_yidong"
      ></zdquczbShow>
      <zdjcqycwbShow
        v-if="editCode == '002'"
        :id="zdjcqyczbId"
        :report_yidong="report_yidong"
      ></zdjcqycwbShow>
      <gyyqjbqkbShow
        v-if="editCode == '003'"
        :id="zdjcqyczbId"
        :report_yidong="report_yidong"
      ></gyyqjbqkbShow>
    </el-dialog>
    <el-dialog
      append-to-body
      title="查看原因"
      :visible.sync="detailDialogVisible"
      :close-on-click-modal="false"
      class="dialog770 titleChange"
    >
      <el-form
        :model="showObj"
        ref="showObjForm"
        label-width="135px"
        class="demo-RuleForm"
        size="small"
        >{{ showObj.reason }}</el-form
      >
    </el-dialog>
    <!-- 查看详情 -->
    <el-dialog
      title="企业详情"
      :visible.sync="showDetailWindow"
      :width="screenWidth < 1200 ? '94%' : '60%'"
      class="titleChange bodyScroll"
      :close-on-click-modal="false"
    >
      <div class="lineTitle">
        <span>基本信息</span>
      </div>
      <el-form
        :inline="true"
        :model="editObj"
        class="demo-form-inline half"
        size="mini"
        label-width="135px"
        label-position="right"
        ref="editForm"
      >
        <el-row>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业名称" prop="name">
              <el-input v-model.trim="editObj.name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="统一社会信用代码">
              <el-input v-model.trim="editObj.code" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="登记注册类型">
              <el-input v-model.trim="editObj.registerType" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="国民经济行业">
              <el-input v-model.trim="editObj.industryType" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册资金（万元）">
              <el-input
                v-model.trim="editObj.registerMoney"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册时间">
              <el-input v-model="editObj.registerTime" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="法定代表人">
              <el-input
                v-model.trim="editObj.representativePerson"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="邮政编码">
              <el-input v-model.trim="editObj.postCode" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="所在工业园区">
              <el-input v-model.trim="editObj.park" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否规上">
              <el-input v-model.trim="editObj.aboveScale" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否上市">
              <el-input v-model.trim="editObj.listed" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否军工">
              <el-input v-model.trim="editObj.military" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业规模">
              <el-input v-model.trim="editObj.companySize" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业类别">
              <el-input
                v-model.trim="editObj.companyCategory"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业性质">
              <el-input
                v-model.trim="editObj.companyNature"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="“565”产业">
              <el-input v-model.trim="editObj.company565" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否10亿元">
              <el-input v-model.trim="editObj.oneBillion" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="提质倍增">
              <el-input
                v-model.trim="editObj.multiplication"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否店小二服务">
              <el-input
                v-model.trim="editObj.xiaoerService"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="“三大改造”实施">
              <el-select v-model="editObj.threeChanges" multiple disabled>
                <el-option label="智能化改造" value="智能化改造"></el-option>
                <el-option label="绿色化改造" value="绿色化改造"></el-option>
                <el-option label="技术改造" value="技术改造"></el-option>
                <el-option label="未实施" value="未实施"></el-option>
                <el-option label="已实施" value="已实施"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册区县" class="selection_item">
              <el-input
                class="city_input_box_1"
                v-model.trim="luoyangCity"
                disabled
                :placeholder="city_name"
              ></el-input>
              <el-input
                class="city_input_box_1"
                v-model.trim="editObj.district"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册地址">
              <el-input
                v-model.trim="editObj.registerAddress"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="24">
            <el-form-item label="办公地址">
              <el-input
                class="address_input_box"
                v-model.trim="editObj.officeAddress"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="24">
            <el-form-item label="公司简介">
              <el-input
                class="address_input_box"
                type="textarea"
                v-model="editObj.companyProfile"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <hr style="width: 100%; margin: 30px 0" />
        <div class="lineTitle" style="width: 100%">联系信息</div>
        <el-row>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系邮箱">
              <el-input v-model.trim="editObj.companyEmail" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="法定代表人电话">
              <el-input
                v-model.trim="editObj.representativePhone"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系人姓名">
              <el-input v-model.trim="editObj.contactName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系人职务">
              <el-input
                v-model.trim="editObj.contactPosition"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系手机" prop="contactPhone">
              <el-input v-model.trim="editObj.contactPhone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系座机">
              <el-input
                v-model.trim="editObj.contactLandlinePhone"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import zdquczbShow from "../../../../Index/Workbench/DataCollection/DataWrite/notInsert/zdquczbShow/index";
import zdjcqycwbShow from "../../../../Index/Workbench/DataCollection/DataWrite/notInsert/zdjcqycwbShow/index";
import gyyqjbqkbShow from "../../../../Index/Workbench/DataCollection/DataWrite/notInsert/gyyqjbqkbShow/index";
import { mapGetters } from "vuex";
import { export2Excel } from "@/utils/utils";
export default {
  name: "index",
  components: {
    zdjcqycwbShow,
    gyyqjbqkbShow,
    zdquczbShow,
  },
  props: {
    report_cycle: {
      type: String,
      default: "",
    },
    method: {
      type: String,
      default: "",
    },
    region: {
      type: String,
      default: "",
    },
    date_range: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
      showDetailWindow: false,
      editObj: {},
      report_yidong: 0,
      tableData: [],
      currentPage: 1,
      loading: false,
      formInline: {
        //查询对象
        name: "",
        region: "",
        report_cycle: "",
        date_range: "",
        above_scale: "",
      },
      exportLabel: "<<点击此处可导出报表",
      pageSize: 10,
      regionTree: [],
      showObj: {},
      total: 0, //表格总数
      detailDialogVisible: false,
      zdjcqyczbId: "",
      editCode: "",
      showDialogVisible: false,
      parkList: [],
      industryList: [],
      registerList: [],
      Company565List: [],
      deftProps: {
        expandTrigger: "hover",
        label: "name",
        value: "name",
      },
      luoyangCity: "",
    };
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
      seatList1: "getAreaListArr",
    }),
  },
  methods: {
    handleDetail1(row) {
      this.$axios
        .get(`/business/selectCompanyEditById?id=${row.id}`)
        .then((res) => {
          console.log(res.data.data);
          this.editObj = res.data.data;
          this.showDetailWindow = true;
        });
    },
    getDateRange(row) {
      const month = Number(row.date_range.split("-")[1]);
      const year = Number(row.date_range.split("-")[0]);
      if (row.report_cycle == 0) {
        //月报
        return row.date_range;
      } else if (row.report_cycle == 1) {
        //季报
        if (month <= 3) {
          return `${year}年第一季度`;
        } else if (month >= 4 && month <= 6) {
          return `${year}年第二季度`;
        } else if (month >= 7 && month <= 9) {
          return `${year}年第三季度`;
        } else {
          return `${year}年第四季度`;
        }
      } else if (row.report_cycle == 2) {
        //半年报
        if (month <= 6) {
          return `${year}年上半年`;
        } else {
          return `${year}年下半年`;
        }
      } else {
        //年报
        return `${year}年`;
      }
    },
    getdata(page) {
      this.loading = true;
      this.tableData = [];
      const param = {
        pageNum: page || 1,
        pageSize: this.pageSize,
        status: 2,
      };
      if (this.formInline.name !== "") {
        param["companyName"] = this.formInline.name;
      }
      console.log(this.formInline.date_range);
      if (this.formInline.date_range && this.formInline.date_range !== "") {
        // param["date_range"] = this.$moment(this.formInline.date_range).format(
        //   "YYYY-MM-dd"
        // );
        param["date"] = this.formInline.date_range;
      }

      // param["date_range"] = this.formInline.date_range;

      let methods = "/business/selectCompanyUpdateMsg";
      // if (this.method === 'noRole') {
      //   methods = '/business/insertMonitor/showCompanyByName'
      // }
      console.log(param);
      this.$axios.get(methods, { params: param }).then((res) => {
        this.loading = false;
        console.log(res.data.data.list);
        res.data.data.list.forEach((item) => {
          item.createTime = item.createTime.slice(0, 10);
          item.handleTime = item.handleTime.slice(0, 10);
          if (item.updateStatus == 1) {
            item.updateStatus = "已提交";
          }
        });
        this.tableData = res.data.data.list;
        console.log(this.tableData);
        this.total = res.data.data.total;
      });
    },
    toDetail(row) {
      this.editCode = row.code;
      this.zdjcqyczbId = row.id;
      this.report_yidong = row.report_yidong;
      this.showDialogVisible = true;
    },
    handleDetail(row) {
      this.showObj = row;
      this.detailDialogVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getdata(val);
    },
    changePage() {
      this.pageNum = this.currentPage;
      this.getdata(this.currentPage);
    },
    handleCurrentChange(val) {
      //跳转页
      this.getdata(val);
    },
    onSubmit() {
      this.getdata();
    },
    reset() {
      this.formInline = {
        name: "",
        region: this.region,
        report_cycle: this.report_cycle,
        date_range: this.date_range,
        above_scale: "",
      };
      this.getdata(1);
    },
    exportData() {
      let column = [
        {
          title: "填报单位",
          key: "company_name",
        },
        {
          title: "报表名",
          key: "name",
        },
        {
          title: "填报期",
          key: "date_range",
        },
        {
          title: "填报开始时间",
          key: "date_range",
        },
        {
          title: "填报结束时间",
          key: "date_range_end",
        },
        {
          title: "上报时间",
          key: "crt_time",
        },
      ];
      export2Excel(column, this.tableData, "审核通过");
    },
  },
  created() {
    if (this.report_cycle) {
      this.formInline.report_cycle = this.report_cycle;
    }
    if (this.region) {
      this.formInline.region = this.region;
    }
    if (this.date_range) {
      this.formInline.date_range = this.date_range;
    }
    this.getdata();
    if (this.seatList1.length) {
      this.city_name = this.seatList1[0];
    }
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
};
</script>

<style scoped>
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
.pagePhone {
  display: none;
}

@media (max-width: 1200px) {
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
}
</style>